import React from 'react';
import Icon from '../AppIcon';

const ProgressIndicator = ({ currentStep = 1, completedSteps = [] }) => {
  const steps = [
    { id: 1, label: 'Profil', path: '/company-profile-form' },
    { id: 2, label: 'Pemasok', path: '/supplier-management' },
    { id: 3, label: 'Operasional', path: '/operational-assessment' },
    { id: 4, label: 'Peralatan', path: '/equipment-analysis' },
    { id: 5, label: 'Keuangan', path: '/financial-analysis-form' },
    { id: 6, label: 'Pasar', path: '/market-assessment' },
    { id: 7, label: 'Tata Kelola', path: '/governance-evaluation' },
    { id: 8, label: 'Analisis', path: '/ai-analysis-dashboard' },
  ];

  const getStepStatus = (stepId) => {
    if (completedSteps?.includes(stepId)) return 'completed';
    if (stepId === currentStep) return 'active';
    return 'pending';
  };

  return (
    <div className="progress-indicator">
      <div className="progress-indicator-content">
        <div className="progress-indicator-steps">
          {steps?.map((step, index) => {
            const status = getStepStatus(step?.id);
            return (
              <React.Fragment key={step?.id}>
                <div className="progress-step">
                  <div className={`progress-step-circle ${status}`}>
                    {status === 'completed' ? (
                      <Icon name="Check" size={20} />
                    ) : (
                      <span>{step?.id}</span>
                    )}
                  </div>
                  <span className={`progress-step-label ${status}`}>
                    {step?.label}
                  </span>
                </div>
                {index < steps?.length - 1 && (
                  <div className={`progress-step-connector ${status === 'completed' ? 'completed' : ''}`} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;